import type { PrintableChapter } from './printableChapter';
import { PrintContentUnits } from './printContentUnits';
import { PrintQuestionSections } from './PrintQuestionRenderer';
import styles from './ChapterPdfDocument.module.css';

interface ChapterPdfDocumentProps {
  chapterTitle: string;
  courseTitle: string;
  includeQuestions: boolean;
  includeVideoUrls: boolean;
  printable: PrintableChapter;
}

export function ChapterPdfDocument({
  chapterTitle,
  courseTitle,
  includeQuestions,
  includeVideoUrls,
  printable,
}: ChapterPdfDocumentProps) {
  const videoLinks = includeVideoUrls ? printable.videoLinks : [];

  return (
    <div className={styles.documentRoot}>
      <div aria-hidden="true" className={styles.runningHeader}>
        {courseTitle} · {chapterTitle}
      </div>

      <article className={styles.document}>
        <header className={styles.titleBlock}>
          <span className={styles.courseTitle}>{courseTitle}</span>
          <h1 className={styles.chapterTitle}>{chapterTitle}</h1>
        </header>

        {videoLinks.length > 0 ? (
          <section className={styles.videoUrls}>
            <h2 className={styles.videoHeading}>Video URLs</h2>
            <ul className={styles.videoList}>
              {videoLinks.map((link) => (
                <li className={styles.videoItem} key={link.id}>
                  <span className={styles.videoTitle}>{link.title}</span>
                  <a className={styles.videoLink} href={link.url}>
                    {link.url}
                  </a>
                </li>
              ))}
            </ul>
          </section>
        ) : null}

        {printable.contentSections.map((section) => (
          <section className={styles.section} key={section.id}>
            <PrintContentUnits
              headingLevel={2}
              includeVideoUrls={includeVideoUrls}
              units={section.units}
            />
          </section>
        ))}

        {includeQuestions ? (
          <PrintQuestionSections
            includeVideoUrls={includeVideoUrls}
            sections={printable.questionSections}
          />
        ) : null}
      </article>
    </div>
  );
}
